import * as Yup from "yup"

// Validaciones para el formulario de facturación
export const validationSchema = Yup.object({
    client: Yup.string().required("El cliente es requerido"),
    rfc: Yup.string().required("El RFC es requerido"),
    companyName: Yup.string().required("La razón social es requerida"),
    postalCode: Yup.string().required("El código postal es requerido"),
    paymentForm: Yup.string().required("La forma de pago es requerida"),
    paymentMethod: Yup.string().required("El método de pago es requerido"),
    usoCfdi: Yup.string().required("El uso CFDI es requerido"),
    fiscalRegimen: Yup.string().required("El régimen fiscal es requerido"),
    emitterRfc: Yup.string().required("El RFC es requerido"),
    emitterCompanyName: Yup.string().required("La razón social es requerida"),
    emitterFiscalRegimen: Yup.string().required("El régimen fiscal es requerido"),
    emitterPostalCode: Yup.string().required("El código postal es requerido"),
})
